module.exports = __webpack_public_path__ + "img/ico-vault.3e5b81ec.svg";